module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABc0lEQVQ4jY3Tz0tUURjG8c+MNhCC066cCEkiI2fVxWUbJbAkN1rtAsVFUAizaNE/URD2Y5F7QTdCUdFCdJc7N6EuJFeKRWApwSyqxX0vo5dm9IXLuTznfO9573OeU0iSRK6uYhI3cTG0TXzAG3w5vLh46L2EaSziG+6iHM+90BbxGqczqBAdlPAOPzGBvXxbUWXM4AxuoZ518Ay/MNYCFnN3YnwK7ejDKC7jbwsYzmMf41jHq6LUsJfRfqu6HtCnWPsck0UMYeEE8Ht0YDm0txgqogdrIV7AZzxoAk/jcejr6GnP7dSFBP1Sf1Zz8JSGTyVxCpu4EuKK9Bj/xD9+bAKLzrfaKpXKJXRjKSZW8RUjGuHKw2Kj3UKSJFWps72OnsR9XEPtP3BneHAjS+ILnJMG6bgsFDCPHTzMkliLr85L49qsypiLsUbjMtUxjG1s4AmqOCX1oRraBr7jdjBHbmMdjzCAs9HNAX5gNrRBaUZ+Z9A/BdVWk4uQGhsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/去过.png
// module id = +Kik
// module chunks = 1